import { render, staticRenderFns } from "./FFileField.vue?vue&type=template&id=3f968704&"
import script from "./FFileField.vue?vue&type=script&lang=ts&"
export * from "./FFileField.vue?vue&type=script&lang=ts&"
import style0 from "./FFileField.vue?vue&type=style&index=0&id=3f968704&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports